import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardActions,
  CardContent,
  Typography,
  Box,
} from '@material-ui/core';
import { useStyles } from './styles';
import { ReactComponent as LanguageIcon } from './assets/language.svg';
import { AudioPlayer } from '../../../../shared/audioPlayer';
import topicTypeLabels from '../../../../../services/topicTypes';
import { MeditationCardProps } from './interface';
import useApi from '../../../../shared/hook/useApi';
import { topicIcons } from '../../../../shared/filters/assets';
import ChipList from '../../../../shared/chip-list';

const MeditationCard: FC<MeditationCardProps> = ({ audio }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [audioPlayed] = useApi('audioPlayed');

  const getMeditationType = (label: string) => {
    const topic = topicTypeLabels.find((type: any) => type.value === label);
    return topic ? topic.label : '';
  };

  const onPlay = () => {
    audioPlayed({
      type: 'meditation',
      name: audio.name,
      language: audio.language,
      topic: audio.topic,
    });
  };

  return (
    <Card className={classes.root}>
      <Box className={classes.cardHeader}>
        <ChipList
          list={[t(getMeditationType(audio.topic))]}
          style={{ margin: 0 }}
        />
      </Box>
      <CardContent className={classes.cardContent}>
        <Box className={classes.cardDescription}>
          <Box className={classes.meditationIcon}>
            {topicIcons?.[audio.topic] ?? topicIcons.default}
          </Box>

          <Box className={classes.descriptionContent}>
            <Typography className={classes.descriptionTitle}>
              {audio.name}
            </Typography>
            <Typography> {audio.description} </Typography>
          </Box>
        </Box>
        <Box className={classes.languageWrapper}>
          <LanguageIcon />
          <Typography component="span" className={classes.language}>
            {t(`Language.${audio.language}`)}
          </Typography>
        </Box>
      </CardContent>
      <CardActions>
        <AudioPlayer url={audio.url} onPlay={onPlay} />
      </CardActions>
    </Card>
  );
};

export default MeditationCard;
